import {
    useContext
} from "react";
import {
    TraceCodeBlockContext
} from "./context";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    Check as CheckIcon,
    Copy as CopyIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";

export const TraceCodeBlockCopyIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const {
        customTheme,
        isCopied
    } = useContext(TraceCodeBlockContext);

    return <AnimatedIcon
        customColor={isCopied ? undefined : customColor}
        color={isCopied ? "success" : color}
        customTheme={customTheme}
        isTransitioned={isCopied}
        iconTransition="morph"
        fromIcon={CopyIcon}
        toIcon={CheckIcon}
        size={size}
    />;
};
